/**
 * Цветът на реда според статуса на плащането - общ за задълженията и за продажбите.
 *
 * Двата екрана показват едни и същи статуси и разминаване между тях само обърква: досега правилото
 * стоеше вписано само в Invoices.tsx, а продажбите излизаха без цвят изобщо.
 *
 * Преходните статуси на печата минават за секунди при нормален печат, така че ред, който стои в някой от
 * тях, всъщност е заседнал - оцветени са в синьо, извън стълбицата зелено-жълто-червено, защото са друг
 * вид състояние, а не степен на успех.
 */
const IN_PROGRESS_STATUSES = ['PRINTING_INITIATED', 'PRINTED', 'BACKEND_SAVING'];

export const invoiceRowClassName = ({ paymentProcessingStatus }: { paymentProcessingStatus?: string }): string =>
    paymentProcessingStatus === 'PRINT_FAILED' || paymentProcessingStatus === 'SAVE_FAILED'
        ? 'invoice-status-failed'
        : paymentProcessingStatus === 'COMPLETED'
            ? 'invoice-status-completed'
            : paymentProcessingStatus === 'PENDING'
                ? 'invoice-status-pending'
                : IN_PROGRESS_STATUSES.includes(paymentProcessingStatus ?? '')
                    ? 'invoice-status-in-progress'
                    : '';

/**
 * Текстът в колоната „Статус на плащане“.
 *
 * Прихванатият с кредитно известие документ е COMPLETED в базата, но не е платен - показва се като
 * прихванат, а не като „Завършено“, за да не се чете като постъпили пари.
 */
export const paymentStatusLabel = (
    { paymentProcessingStatus, creditNoteOffset }: { paymentProcessingStatus?: string; creditNoteOffset?: unknown },
    translate: (key: string) => string,
    empty: string,
): string =>
    creditNoteOffset
        ? translate('status_CREDIT_NOTE_OFFSET')
        : paymentProcessingStatus ? translate(`status_${paymentProcessingStatus}`) : empty;
